import React, { Component } from "react";
import { connect } from "react-redux";

class Beacon extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { app } = this.props;
    const { isMobile } = app;

    const mobileStyle = {
      display: "none",
      position: "absolute",
      height: "200px",
      width: "80vw",
      overflow: "hidden",
      top: 20,
      left: 20,
      zIndex: 1,
    };

    const desktopStyle = {
      display: "none",
      position: "absolute",
      height: "200px",
      width: "300px",
      overflow: "hidden",
      top: 20,
      left: window.innerWidth / 2 - 150,
      zIndex: 1,
    };

    const style = isMobile ? mobileStyle : desktopStyle;

    return <div style={style}>coming soon.... beacons.js</div>;
  }
}

const mapStateToProps = (state, ownProps) => ({
  app: state.app,
  location: ownProps.location,
});

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Beacon);



// WEBPACK FOOTER //
// ./src/components/beacons/beacon/Beacon.js